import { Container } from '@material-ui/core';
import React from 'react';
import { useCurrentRoute } from 'react-navi';
import FlockProfileWrapper from './flock-profile-wrapper';
import FlockProfilesList from './flock-profiles-list/flock-profiles-list';
import './flock-profiles.scss';

type FlockProfilesRouteData = {
  companyId?: number;
  companyName?: string | null;
  isAdmin: boolean;
};

const getCompanyId = (value: unknown): number | undefined => {
  if (typeof value !== 'string' && typeof value !== 'number') {
    return undefined;
  }

  const companyId = Number(value);

  return Number.isInteger(companyId) && companyId > 0
    ? companyId
    : undefined;
};

export const FlockProfiles: React.FC = () => {
  const route = useCurrentRoute();
  const routeData = route.data as FlockProfilesRouteData | undefined;
  const companyId = getCompanyId(routeData?.companyId);
  const companyName = typeof routeData?.companyName === 'string'
    ? routeData.companyName
    : undefined;
  const isAdminCompanyContext = Boolean(routeData?.isAdmin);
  const adminListPath = isAdminCompanyContext
    ? '/flock-profiles'
    : undefined;
  const adminToolsPath = isAdminCompanyContext
    ? `/admin/companies/${companyId}/tools`
    : undefined;

  return (
    <FlockProfileWrapper
      title='Flock Profiles'
      backRoute={adminToolsPath}
    >
      <Container className='flock-profiles__container'>
        <FlockProfilesList
          companyId={isAdminCompanyContext ? companyId : undefined}
          companyName={isAdminCompanyContext ? companyName : undefined}
          returnToPath={adminListPath || '/flock-profiles'}
        />
      </Container>
    </FlockProfileWrapper>
  );
};

export default FlockProfiles;
